<template>
  <div>
    <f7-button
      class="boton-eliminar-materiales"
      style="max-width: 109px"
      type="default"
      styling-mode="contained"
      name="ButtonMaterialRequest"
      @click="deleteMaterials"
    >
      {{ $t('deleteAll') }}
    </f7-button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DeleteSelectedMaterials',
  methods: {
    ...mapActions('materialRequest', ['deleteAllMaterailsSelected']),
    deleteMaterials() {
      this.deleteAllMaterailsSelected();
    },
  },
};
</script>
<style>
.boton-eliminar-materiales {
  /* que parezca un enlace, no un botón */
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;

  display: inline-flex;
  align-items: center;
  justify-content: flex-start;

  padding: 0 !important;
  min-width: auto;
  height: auto;

  font-size: 14px;
  font-weight: 400;
  color: #00346a !important;
  text-decoration: underline; /* como en la captura */

  /* por si F7 mete border-radius */
  border-radius: 0 !important;
}
</style>
